import React, { useState } from 'react';
import { toast } from 'sonner';
import { IconPhone } from '../components/Icons';
import { useVerifica } from './VerificaContext';

// Input di ricerca-per-numero: avvia la verifica combinata (456 + GEA automatica) via il
// VerificaProvider, che gestisce progresso/esito/background. Riusato da /cerca e dalla lente.
export default function QuickSearch({ onStart }) {
  const [numero, setNumero] = useState('');
  const { start } = useVerifica();

  const go = () => {
    const n = numero.trim();
    if (!n) { toast.info('Inserisci un numero'); return; }
    start(n);
    setNumero('');
    if (onStart) onStart();
  };

  return (
    <>
      <div className="m-field">
        <span style={{ color: 'var(--muted)', display: 'flex' }}><IconPhone size={18} /></span>
        <input
          value={numero}
          onChange={(e) => setNumero(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') go(); }}
          placeholder="Numero fisso"
          inputMode="tel"
        />
      </div>
      <button className="m-btn start" onClick={go} style={{ marginBottom: 6 }}>Verifica ora</button>
      <div className="m-empty">Si verifica il 456 e, se NON TIM o TIM non attiva, anche Vodafone. Il numero non viene archiviato.</div>
    </>
  );
}
